/* globals Log, disabledLogEntry */
/* eslint-disable new-cap */
function HistoryLogger (recordHistory, recordHistoryDetailed, version) {
    this.auditCount = 0;

    this.RecordHistory = recordHistory;
    this.RecordHistoryDetailed = recordHistoryDetailed;
    if (this.RecordHistoryDetailed) {
        this.RecordHistory = true;
    }

    this.currentEntry = null;
    this.DataExists = false;
    this.version = version;
    this.includeTimestamps = true;

    // Create our own log, always include timestamps
    this.log = new Log(version, true, "RTL");
}

HistoryLogger.prototype = {
    DataIsAvailable: function () {
        return this.DataExists;
    },

    WriteEvent: function (args, atts, parentEntry) {
        var myArgs,
            attribute;

        if (this.RecordHistory) {
            // If we have an event then don't bother writing the args entry
            myArgs = typeof atts !== "undefined" && atts !== null && atts.event ? "" : args;

            if (typeof parentEntry === "undefined" || parentEntry === null) {
                this.currentEntry = this.log.startNew("RT", myArgs);
            }
            else {
                this.currentEntry = parentEntry.startNew("RT", myArgs);
            }

            this.currentEntry.setAttribute("id", this.auditCount += 1);

            for (attribute in atts) {
                if (atts.hasOwnProperty(attribute)) {
                    this.currentEntry.setAttribute(attribute, atts[attribute]);
                }
            }

            return this.currentEntry;
        }

        return disabledLogEntry;
    },

    WriteEventReturnValue: function (str, atts, parentEntry) {
        var attribute;

        // Only possibility for null is when dynamically turning on logging at runtime
        // (not currently supported for history logger)
        if (this.currentEntry === null) {
            return;
        }

        if (this.RecordHistory) {
            this.currentEntry.setReturn(str);
            for (attribute in atts) {
                if (atts.hasOwnProperty(attribute)) {
                    this.currentEntry.setAttribute(attribute, atts[attribute]);
                }
            }
        }

        if (typeof parentEntry !== "undefined" && parentEntry !== null) {
            this.currentEntry = parentEntry;
        }
        else {
            // this.AssertError("HistoryLogger.WriteEventReturnValue() called without parentEntry");
        }
    },

    WriteEventDetailed: function (args, atts, parentEntry) {
        var myArgs,
            attribute;

        if (this.RecordHistoryDetailed) {
            // If we have an event then don't bother writing the args entry
            myArgs = typeof atts !== "undefined" && atts !== null && atts.event ? "" : args;
            if (typeof parentEntry === "undefined" || parentEntry === null) {
                this.currentEntry = this.log.startNew("RT", myArgs);
            }
            else {
                this.currentEntry = parentEntry.startNew("RT", myArgs);
            }

            this.currentEntry.setAttribute("id", this.auditCount += 1);

            for (attribute in atts) {
                if (atts.hasOwnProperty(attribute)) {
                    this.currentEntry.setAttribute(attribute, atts[attribute]);
                }
            }

            return this.currentEntry;
        }

        return disabledLogEntry;
    },

    WriteEventDetailedReturnValue: function (str, atts, parentEntry) {
        var attribute;

        // Only possibility for null is when dynamically turning on logging at runtime
        // (not currently supported for history logger)
        if (this.currentEntry === null) {
            return;
        }

        if (this.RecordHistoryDetailed) {
            this.currentEntry.setReturn(str);
            for (attribute in atts) {
                if (atts.hasOwnProperty(attribute)) {
                    this.currentEntry.setAttribute(attribute, atts[attribute]);
                }
            }
        }

        if (typeof parentEntry !== "undefined" && parentEntry !== null) {
            this.currentEntry = parentEntry;
        }
        else {
            // this.AssertError("HistoryLogger.WriteEventDetailedReturnValue() called without parentEntry");
        }
    },

    GetSerializedLog: function () {
        /* globals XmlElement */
        var rootElement = new XmlElement("RTL"),
            i,
            entry,
            xmlEntry,
            attribute;

        rootElement.AddAttribute("version", this.version);
        rootElement.AddAttribute("browser", this.log.browser);

        for (i = 0; i < this.log.entries.length; i += 1) {
            entry = this.log.entries[i];
            xmlEntry = new XmlElement("RT");

            xmlEntry.AddAttribute("ts", entry.formatTimestampForLog());
            xmlEntry.AddAttribute("ts_utc", entry.formatTimestampForLog(true));
            xmlEntry.AddAttribute("f", entry.functionName);

            for (attribute in entry.attributes) {
                if (entry.attributes.hasOwnProperty(attribute)) {
                    xmlEntry.AddAttribute(attribute, entry.attributes[attribute]);
                }
            }

            rootElement.AddElement(xmlEntry);
        }

        return rootElement;
    }
};
